//React
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//API
import { LoginApi } from "../../api";
//LocalStorage
import SecureStorage from "react-secure-storage";
//Material UI
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
//Components
import CircularProgress from "../../components/CircleProgress";
//Assets
import Logo from "../../assets/images/logo.svg";

//CSS
import "./Login.css";

const Login = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [capsLock, setCapsLock] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const setData = () => {
      SecureStorage.clear();
    };
    setData();
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordShown(!passwordShown);
  };

  const checkCapsLock = (e) => {
    const capsLockOn = e.getModifierState("CapsLock");
    setCapsLock(capsLockOn);
  };

  const handlePasswordKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!disabled && !loading) {
        handleLogin();
      }
    } else {
      checkCapsLock(e);
    }
  };
  
  const handleLogin = async () => {
    if (userId.trim() === "" || password.trim() === "") {
      setDisabled(true);
      alert("아이디와 비밀번호를 입력해주세요.");
      setDisabled(false);
      return;
    }
    setDisabled(true);
    setLoading(true);

    const response = await LoginApi.login({
      userId: userId,
      password: password,
    });
    if (response.status === 200) {
      SecureStorage.setItem("isLoggedIn", "true");
      SecureStorage.setItem("doctorId", response.data.doctorId);
      SecureStorage.setItem("userName", response.data.username);
      
      const channel = new BroadcastChannel('auth-channel');
      channel.postMessage({
        type: 'LOGIN',
        doctorId: response.data.doctorId,
        userName: response.data.username,
      });
      channel.close();
      
      navigate("/main", { replace: true });
    } else {
      alert("아이디 또는 비밀번호가 일치하지 않습니다.");
      setDisabled(false);
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-title">
        <Logo alt="logo" />
        <div>AI Rotator cuff REGEN</div>
      </div>
      <div className="login-box">
        <div className="login-form">
          <div className="login-heading">Login</div>
          <div className="login-form-group">
            <div className="login-form-group-id">
              <div className="login-label">ID</div>
              <input
                className="login-input"
                type="text"
                placeholder="ID를 입력해주세요."
                value={userId}
                disabled={disabled}
                onChange={(e) => setUserId(e.target.value)}
              />
            </div>
            <div className="login-form-group-password">
              <div className="login-label">PW</div>
              <div className="login-password-wrapper">
                <input
                  className="login-input"
                  type={passwordShown ? "text" : "password"}
                  placeholder="비밀번호를 입력해주세요."
                  onKeyDown={handlePasswordKeyDown}
                  onKeyUp={checkCapsLock}
                  value={password}
                  disabled={disabled}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  className="login-password-toggle"
                  onClick={togglePasswordVisibility}
                >
                  {passwordShown ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </button>
              </div>
              <div className="login-capslock-info">
                {capsLock ? (
                  <>
                    <InfoOutlinedIcon sx={{ fontSize: 18 }} />
                    <div className="login-capslock-text">Caps Lock is On</div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
        <button
          className={`login-button ${loading ? "loading" : ""}`}
          type="button"
          onClick={handleLogin}
          disabled={disabled || loading}
        >
          {!loading ? (
            "Login"
          ) : (
            <CircularProgress color="white" thickness={4} size={19} />
          )}
        </button>
      </div>
    </div>
  );
};

export default Login;
